



























































import Vue from "vue";
import Component from "vue-class-component";
import {Prop, Watch} from "vue-property-decorator";
import RequestRepository from "@/repositories/request/RequestRepository";
import {Getter} from "vuex-class";
import Specifications from "@/components/forms/request/Specifications.vue";
import {Request} from "@/modules/request/Request";
import _ from "lodash";

interface Filters {
    searchRequest: string;
    ownerUuid: string;
    main_request: boolean;
    scopeOwnerUuid?: string;
}

interface SearchResult {
    value: string;
    uuid: string;
}

@Component({
    components: {Specifications}
})
export default class MoveRequest extends Vue {
    @Prop({required: true}) private openMoveRequest!: boolean;
    @Prop({required: true}) private request!: Request;
    @Prop({required: true}) private requestMain!: Request;
    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string;

    private moveRequest: string = "";
    private loading: boolean = false;
    private results: object[] = [];
    private selectedRequest: Request | null = null;

    @Watch("moveRequest") private onMoveRequestChange(newValue: string): void {
        if (newValue === "") {
            this.selectedRequest = null;
        }
    }

    private searchMoveRequest(query: string, cb: (args: SearchResult[]) => void): void {
        if (!query) {
            cb([]);
            return;
        }
        if (query.length < 3) {
            return;
        }
        this.loading = true;
        const params: { filters: Filters } = {
            filters: {
                searchRequest: query,
                ownerUuid: this.currentOwnerUuid,
                main_request: true,
            }
        };
        if (this.request.scopeOwner && this.request.scopeOwner.uuid) {
            params.filters.scopeOwnerUuid = this.request.scopeOwner.uuid;
        }

        RequestRepository.get(params)
            .then((response: object[]) => {
                const result: Array<{ value: string, uuid: string }> = [];
                this.results = response;
                _.forEach(response, (suggestion: object) => {
                    if (_.get(suggestion, "uuid", "") === this.requestMain.uuid) {
                        return;
                    }
                    result.push({
                        value: _.get(suggestion, "code", "") + " - " +
                            _.get(suggestion, "title", ""),
                        uuid: _.get(suggestion, "uuid", "")
                    });
                });
                cb(result);
            })
            .catch(() => {
                cb([]);
            })
            .finally(() => {
                this.loading = false;
            });
    }

    private handleSelect(item: Request): void {
        this.selectedRequest = _.find(this.results as Request[], (o) => o.uuid === item.uuid) || null;
    }

    private closed(): void {
        this.$emit("close-drawer-move-request");
        this.selectedRequest = null;
        this.moveRequest = "";
    }

    private saveRequest(): void {
        if (!confirm(_.invoke(this.$options.filters, "trans", "moveRequestConfirm"))) {
            return;
        }
        if (!this.selectedRequest || !this.selectedRequest.uuid) {
            return;
        }
        this.request.parent = {uuid: this.selectedRequest.uuid ? this.selectedRequest.uuid : ""};
        RequestRepository.save(this.request)
            .then(() => {
                this.$emit("reload-request");
                this.closed();
            });
    }
}
